import {AbstractEvent} from "@/modules/base/events";
import {GateTypeEnum} from "@/modules/action-points/enums";
import {Team} from "@/modules/team/entity";

export default class AfterCurrencyExchangeEvent extends AbstractEvent {
  constructor(
    public team: Team,
    public type: GateTypeEnum,
    public value: number,
    public coins: number,
  ) {
    super();
  }
}